import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { accountService } from "../../services/enhancedCrudService";
import { toast, ToastContainer } from "react-toastify";

const AccountLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [subscriptionCounts, setSubscriptionCounts] = useState({
    seller_count: 200,
    buyer_count: 1000,
  });
  const [formData, setFormData] = useState({
    identifier: "",
    pin: "",
  });

  function generateUUID() {
    if (crypto.randomUUID) {
      let id = localStorage.getItem("uniqueId");
      if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem("uniqueId", id);
      }
      return id;
    } else {
      let id = localStorage.getItem("uniqueId");
      if (!id) {
        id = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        );
        localStorage.setItem("uniqueId", id);
      }
      return id;
    }
  }
  useEffect(() => {
    const id = generateUUID();
    setDeviceId(id);
    const fetchSubscriptionCount = async () => {
      try {
        const response = await accountService.getUserSubscriptionCount();
        console.log("Subscription count response:", response);
        if (
          response.seller_count !== undefined &&
          response.buyer_count !== undefined
        ) {
          setSubscriptionCounts({
            seller_count: response.seller_count || 300,
            buyer_count: response.buyer_count || 1000,
          });
        }
      } catch (error) {
        console.error("Error fetching subscription count:", error);
      }
    };

    fetchSubscriptionCount();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const loginData = {
        ...formData,
        identifier: `(+91)${formData.identifier}`,
        device_id: deviceId,
      };

      const response = await accountService.login(loginData);
      console.log("Login response:", response);

      if (response.accessToken) {
        sessionStorage.setItem("accessToken", response.accessToken);
        sessionStorage.setItem("refreshToken", response.refreshToken);
        sessionStorage.setItem("user", JSON.stringify(response.user));

        if (response.user.seller_profile.is_disabled) {
          toast.error(
            "Your account has been disabled. Please contact the administrator."
          );
          return;
        }

        toast.success("Login successful!");

        if (response.user.seller_profile.subscription_status) {
          navigate("/sellers/profile");
        } else if (response.user.seller_profile.payment_received) {
          navigate("/subscription?payment=1");
        } else {
          navigate("/subscription?payment=0");
        }
      } else {
        toast.error("Login failed. Please check your credentials.");
      }
    } catch (error) {
      let message = "Login failed. Please check your credentials.";
      if (error.response && error.response.data) {
        message =
          error.response.data.non_field_errors?.length > 0
            ? error.response.data.non_field_errors[0]
            : message;
      }
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper login-body">
      <div className="lander-page">
        <div className="left-panel">
          <div className="logo">
            <img
              src={"/assets/img/logo.png"}
              alt="Morbi Bazaar Logo"
              className="logo-image"
            />
          </div>

          <h1 className="headline">
            Boost Your Sales with{" "}
            <span className="highlight">Countrywide Buyers</span>
          </h1>

          <p className="subheadline">
            Connect with verified ceramic buyers across India and expand your
            business reach with our trusted marketplace platform.
          </p>

          <ul className="features">
            <li>
              <span className="checkmark">✓</span> Reach Verified Buyers –
              Dealers from all over India.
            </li>
            <li>
              <span className="checkmark">✓</span> Your Digital Profile Page –
              Like your mini-website.
            </li>
            <li>
              <span className="checkmark">✓</span> Upload Stock in Minutes – PDF
              or images, updated instantly.
            </li>
            <li>
              <span className="checkmark">✓</span> Direct WhatsApp Inquiries –
              Talk to buyers directly.
            </li>
            <li>
              <span className="checkmark">✓</span> Zero Commission – 100% profit
              is yours.
            </li>
          </ul>

          <div className="stats">
            <div className="stat-item">
              <div className="stat-number">
                {subscriptionCounts.buyer_count}+
              </div>
              <div className="stat-label">Active Buyers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">
                {subscriptionCounts.seller_count}+
              </div>
              <div className="stat-label">Active Seller</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support</div>
            </div>
          </div>
        </div>

        <div className="right-panel">
          <div className="login-wrapper">
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group position-relative">
                <label>Mobile Number</label>
                <input
                  type="text"
                  className="form-control mobile-number-input input-form-input"
                  name="identifier"
                  value={formData.identifier}
                  onChange={handleInputChange}
                  placeholder="Enter mobile number"
                  maxLength="10"
                  pattern="[0-9]{10}"
                  title="Please enter a valid 10-digit mobile number"
                  required
                />
                <span className="span-91">+91</span>
              </div>
              <div className="form-group">
                <label>4-digit PIN</label>
                <input
                  type="password"
                  className="form-control input-form-input"
                  name="pin"
                  value={formData.pin}
                  onChange={handleInputChange}
                  placeholder="Enter your PIN"
                  maxLength="4"
                  pattern="[0-9]{4,6}"
                  title="PIN should be 4-6 digits"
                  required
                />
              </div>
              <div className="form-group text-end">
                <button
                  type="submit"
                  className="btn btn-block login-button"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </div>
              <div className="forgotPin">
                <Link className="forgot-btn" to="/forget-pin">
                  Forget-Pin?
                </Link>
              </div>
              <div className="form-group text-end form-footer">
                <button
                  type="button"
                  className="btn btn-block login-btn"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Create new account
                </button>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default AccountLogin;
